export default __webpack_public_path__ + "static/media/robustoClosed.448fab14.jpg";